import Lookup from './lookup.js';

export default class IssuerResidentialCard  extends Lookup
{
    
}
